<template>
  <div class="qaqc-cce-test-view">
    <DataQualityScorecardTable
      :rows="scorecardRows"
      :summary="scorecardSummary"
      :dataset-label="datasetLabel"
    />
    <ValidationPassRateMatrixTable
      :rows="validationMatrixRows"
      :title="validationMatrixTitle"
      :description="validationMatrixDescription"
      matrix-test-context="cce"
    />
  </div>
</template>

<script>
import DataQualityScorecardTable from "./DataQualityScorecardTable.vue";
import ValidationPassRateMatrixTable from "./ValidationPassRateMatrixTable.vue";

export default {
  name: "CCETestView",
  components: {
    DataQualityScorecardTable,
    ValidationPassRateMatrixTable,
  },
  props: {
    scorecardRows: { type: Array, default: () => [] },
    scorecardSummary: {
      type: Object,
      default: () => ({
        overallPassRate: "0%",
        passedQc: 0,
        pendingQc: 0,
        failed: 0,
      }),
    },
    validationMatrixRows: { type: Array, default: () => [] },
    validationMatrixTitle: { type: String, default: "Validation Pass Rate Matrix" },
    validationMatrixDescription: { type: String, default: "Percentage of all CCE samples passing each validation check" },
    datasetLabel: { type: String, default: "CCE Dataset" },
  },
};
</script>
